import React, { useEffect, useRef } from 'react';
import Backdrop from "./Backdrop";

const BackdropWrapper = ({
    children,
    showTooltip,
    wrapperClass,
    ...rest
}) => {

    return (<div className={`${wrapperClass ? wrapperClass : ''} ${showTooltip ? 'backdrop-tooltip-enabled' : ''}`}>
        {children}
        {showTooltip &&
            <Backdrop
                showTooltip={showTooltip}
                {...rest}
            />
        }
    </div>);
};

export default BackdropWrapper;

